import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NotesModule } from '@notes/notes.module';
import { CoreModule } from '@core/core.module';
import { ContactDetailsModule } from '../contact-details/contact-details.module';
import { NgRatingBarModule } from 'ng-rating-bar';
import { SharedModule } from '@shared/shared.module';
import { IConfig, NgxMaskDirective, NgxMaskPipe, provideEnvironmentNgxMask } from 'ngx-mask';
import { StickybitsModule } from 'ngx-stickybits';

import { LaneDetailsComponent } from './lane-details/lane-details.component';
import { BrokerLaneDetailsComponent } from './broker-lane-details/broker-lane-details.component';
import { CoreTasksModule } from '../broker/tasks/core-tasks/core-tasks.module';
import { MatLegacyTabsModule as MatTabsModule } from '@angular/material/legacy-tabs';

const maskConfig: Partial<IConfig> = {};

const components = [LaneDetailsComponent, BrokerLaneDetailsComponent];

@NgModule({
	declarations: [components],
	imports: [
		NotesModule,
		CoreModule,
		ContactDetailsModule,
		NgRatingBarModule,
		SharedModule,
		CommonModule,
		CoreTasksModule,
		MatTabsModule,
		NgxMaskDirective,
		NgxMaskPipe,
		StickybitsModule,
	],
	exports: [...components],
	providers: [provideEnvironmentNgxMask(maskConfig)],
})
export class CarrierFullProfileModule {}
